module.exports = __webpack_public_path__ + "assets/img/jiantou.b818a916.svg";